"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var remove_node_button_component_1 = __importDefault(require("../remove-node-button/remove-node-button.component"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var RemoveCurrentNodeButtonContainer = function RemoveCurrentNodeButtonContainer(props) {
  var dispatch = react_redux_1.useDispatch();
  return react_1.default.createElement(remove_node_button_component_1.default, Object.assign({
    removeNode: function removeNode() {
      dispatch(scenario_actions_1.default.removeCurrentNode());
    }
  }, props));
};

exports.default = RemoveCurrentNodeButtonContainer;